import React, { useMemo } from 'react';

import sortPrizeListAndGetPrizeStatus from 'client/components/Result/prizeList/sortPrizeList';
import PrizeListItem from 'client/components/Result/prizeList/PrizeListItem';

export default function PrizeList({ onClick, items = [], showPromoInfo }) {
    const sortedPrizes = useMemo(() => sortPrizeListAndGetPrizeStatus(items), [items]);

    return sortedPrizes.map((item = {}) => {
        const {
            statusLabel,
            prize,
            prizeSettings,
            promotion,
            entryId,
            entryUuid,
            winnerStatus,
            winnerCreatedAt
        } = item;
        return (
            <PrizeListItem
                key={`${entryUuid}-${prize?.uuid}`}
                prize={prize}
                prizeSettings={prizeSettings}
                promoInfo={promotion}
                winnerStatus={{ ...winnerStatus, winnerCreatedAt, entryId, entryUuid }}
                onClick={e => onClick(e, item)}
                statusLabel={statusLabel}
                showPromoInfo={showPromoInfo}
            />
        );
    });
}
